<template>
  <div>
    <div class="changePhoneNumber" v-if="$route.params.type===0">
      <div class="title">
        <p>修改密码</p>
      </div>
      <div class="contair">
        <el-steps :active="stepNumber">
          <el-step title="步骤 1" description="验证身份"></el-step>
          <el-step title="步骤 2" description="修改手机号码"></el-step>
          <el-step title="步骤 3" description="完成"></el-step>
        </el-steps>
        <div class="lines"></div>
        <div v-if="stepNumber===0">
          <div class="stepOne">
            <p class="tips"><i class="iconfont icon-gantanhao"></i>&nbsp;&nbsp;为确认是您本人操作，请完成以下验证</p>
            <div class="phoneNumber">
              <div class="leftbox">
                <p>已验证手机：</p>
              </div>
              <div class="rightbox">
                <p>{{phoneNumber}}</p>
              </div>
            </div>
            <div class="phoneInput">
              <div class="leftbox">
                <p>短信验证码：</p>
              </div>
              <div class=" message">
                <!-- <input v-model="message"/> -->
                <el-input v-model="message"></el-input>
                <div class="sendMessage">
                  <a :href="'sms:'+information.phone">免费获取短信验证码</a>
                </div>
                <div class="noSend">没收到短信验证码？</div>
              </div>
            </div>
            <div class="btnBox">
              <div class="leftbox"></div>
              <button class="nextButton" @click="toNextStep(1)">下一步</button>
            </div>
          </div>
        </div>
        <div v-if="stepNumber===1">
          <div><h1>22222</h1></div>
        </div>
        <div v-if="stepNumber===2">
          <div><h1>33333</h1></div>
        </div>
      </div>
    </div>
    <div class="changePhoneNumber" v-if="$route.params.type===1">
        <div class="title">
          <p>修改注册邮箱</p>
        </div>
        <div class="contair">
          <el-steps :active="otherStepNumber">
            <el-step title="步骤 1" description="验证身份"></el-step>
            <el-step title="步骤 2" description="修改注册邮箱"></el-step>
            <el-step title="步骤 3" description="完成"></el-step>
          </el-steps>
          <div class="lines"></div>
          <div v-if="otherStepNumber===0">
            <div class="stepOne">
              <p class="tips"><i class="iconfont icon-gantanhao"></i>&nbsp;&nbsp;为确认是您本人操作，请完成以下验证</p>
              <div class="phoneNumber">
                <div class="leftbox">
                  <p v-if="isphone">已验证手机：</p>
                  <p v-else>已验证邮箱：</p>
                </div>
                <div class="rightbox">
                  <p class="number" v-if="isphone">{{phoneNumber}}</p>
                  <p v-else>{{Email}}</p>
                </div>
                <div class="mailBox">
                  <p class="mail" @click="changeWay(1)" v-if="isphone">通过已验证邮箱验证</p>
                  <p class="mail" @click="changeWay(2)" v-else>通过已验证手机验证</p>
                </div>
              </div>
              <div class="phoneInput">
                <div class="leftbox">
                  <p>短信验证码：</p>
                </div>
                <div class=" message">
                  <!-- <input v-model="otherMessage"/> -->
                  <el-input v-model="otherMessage"></el-input>
                  <div class="sendMessage">
                    <a :href="'sms:'+information.phone">免费获取短信验证码</a>
                  </div>
                  <div class="noSend">没收到短信验证码？</div>
                </div>
              </div>
              <div class="btnBox">
                <div class="leftbox"></div>
                <button class="nextButton" @click="toNextStep(2)">下一步</button>
              </div>
            </div>
          </div>
          <div v-if="otherStepNumber===1">
            <div><h1>22222</h1></div>
          </div>
          <div v-if="otherStepNumber===2">
            <div><h1>33333</h1></div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
  export default ({
    name:'changePhoneNumber',
    comments:{},
    data() {
      return {
        stepNumber:0,
        information:{
          phone:'12345678912',
        },
        otherStepNumber:0,
        phoneNumber:'',
        Email:'1234567891@qq.com',
        message:'1',
        received:'1',//获取到的验证码
        isphone:true,
        otherMessage:'2',
        otherReceived:'2',//获取到的验证码
      }
    },
    mounted() {
      if(this.information.phone && this.information.phone!==''){
        this.changPhoneNumber(this.information.phone)
      }
    },
    methods:{
        changPhoneNumber(number){
           this.phoneNumber =  number.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")
        },
        toNextStep(number){
          if(number==1){
            if(this.message!=='' && this.message===this.received){
              this.stepNumber=1;
            }
          }else {
            if(this.otherMessage!=='' && this.otherMessage===this.otherReceived){
              this.otherStepNumber=1;
            }
          }
        },
        changeWay(number) {
          if(number==1){
            this.isphone=false;
          }else {
            this.isphone=true;
          }
        }
    }
  })
</script>

<style lang="scss" scoped>
  p{margin: 0px;padding: 0px;}
  .changePhoneNumber{width: 100%;height:100%;background: rgb(244,245,246);}
  >>>.contair{width: 1280px;height: calc(100vh - 137px);;margin: 0px auto;background: #ffffff;padding: 20px 20px;box-sizing: border-box;}
  .title{height: 40px;width: 1280px;margin: 0px auto;padding: 8px 0px;}
  .title>p{font-size: 18px;line-height: 40px;color: #222;}
  >>>.el-step__title.is-process{font-weight: normal;}
  >>>.el-step__description.is-process{color: #444;}
  .icon-gantanhao{color: $color-primary;font-size: 18px;vertical-align: 0;}
  .stepOne{width: 800px;margin-left: 300px;}
  .phoneNumber{display: flex;margin-bottom: 10px;}
  .phoneInput{display: flex;}
  .message{display: flex;}
  .lines{height: 1px;width: 100%;margin-top: 10px;margin-bottom: 10px;background: rgb(238,238,238);}
  .tips{height: 40px;font-size: 16px;line-height: 40px;margin-top: 40px;margin-bottom: 20px;color: #555;}
  .leftbox{width: 15%;font-size: 16px;min-height: 1px;}
  .leftbox>p{line-height: 43px;color: #555;}
  .rightbox{line-height: 43px;width: 190px;}
  .rightbox>p{color: #666;padding-left: 5px;}
  .sendMessage{padding:0px 15px;border: 1px solid $color-primary;margin-left: 10px;background: $color-primary;height: 40px;line-height: 40px;box-sizing: border-box;}
  .sendMessage:hover{cursor: pointer;background: #f78989;}
  .sendMessage>a{text-decoration: none;color: #fff;}
  .message>>>.el-input{width: 180px;}
  .message>>>.el-input__inner{color: #666;width: 180px;padding-left: 5px;border-radius: $border-radius;}
  .noSend{color:$color-primary ;line-height: 40px;margin-left: 10px;height: 40px;}
  .btnBox{display: flex;margin-top: 30px;}
  .nextButton{color: #ffffff;background:$color-primary;outline: none;border: 1px solid $color-primary;padding: 10px 15px;}
  .nextButton:hover{cursor: pointer;background: $color-primary-light-1;}
  .sendMessage,.noSend{cursor: pointer;}
  .mailBox{margin-left: 10px;}
  .mail{line-height: 43px;color:$color-primary ;}
  .mail:hover{cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/changePhoneNumber.vue